import React, { useState } from 'react'
import clsx from 'clsx'

export default function CustomCursor({ position, goBack, goForwards, isPositionOutside }) {
    const [clicked, setClicked] = useState(false)
    const parentWidth = document.querySelector('.fullParent')?.offsetWidth
    const x = position.x
    const y = position.y
    const handleClick = () => {
        setClicked(true)
        setTimeout(() => {
            setClicked(false)
        }, 300);
        return (x < (parentWidth / 2)) ? goBack() : goForwards()
    }
    return (
        <div
            onClick={() => handleClick()}
            className={
                clsx('cursor-point',
                    isPositionOutside && 'cursorFadeOut',
                    (x < (parentWidth / 2)) && 'cursor-left',
                    (x > (parentWidth / 2)) && 'cursor-right'
                )}
            style={{ transform: `translate(${x - 55}px, ${y - 55}px) scale(${clicked ? 0.7 : 1})` }}
        >

        </div>
    )
}
